import React, { Component } from 'react'
import "./css/Footer.css"
import 'bootstrap/dist/css/bootstrap.min.css';



export default class MyFooter extends Component {
        render() {
                return (
                        <div id="main-footer">
                                <div className="w-100 text-center pt-4">
                                        <p>@ 2021 Copyright: <a href="/">analyzeit.com</a></p>
                                </div>
                        </div>
                )
        }
}
